// Centralized helper for calling /api/anthropic with Clerk auth attached.
// All three AI features (PromptImport, SketchImport, LayoutAnalyzer) use this
// so token handling and error format stay consistent. When we add usage
// logging in Phase 4, the hook point is here.
//
// Usage:
//   const { getToken } = useAuth();          // from @clerk/clerk-react
//   const data = await aiFetch(body, getToken);

export async function aiFetch(body, getToken) {
  // Pull a fresh session token. Clerk tokens are short-lived (~60s) so we
  // never cache — always grab at call time.
  const token = await getToken();

  if (!token) {
    // Should not happen if the UI gating worked, but handle gracefully
    throw new Error('Not signed in. Please sign in to use AI features.');
  }

  const response = await fetch('/api/anthropic', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  // Map common auth/server errors to user-friendly messages
  if (response.status === 401) {
    throw new Error('Your session has expired. Please sign in again.');
  }
  if (response.status === 403) {
    throw new Error('Your account is not authorized to use AI features.');
  }
  if (!response.ok) {
    let detail = '';
    try { detail = await response.text(); } catch { /* ignore */ }
    throw new Error(`API error ${response.status}${detail ? `: ${detail}` : ''}`);
  }

  return response.json();
}
